/* Mobile QA 2026-10-14 (M9): the dealer tables (My Orders, order items, related records)
   stack into cards on phones. Each cell gets its column header as data-label so the
   phone CSS can print "PO Number  041394" style rows. Re-runs whenever rows are re-rendered. */
(function () {
  function label(table) {
    var heads = table.querySelectorAll('thead th');
    if (!heads.length) return;
    var names = [];
    for (var i = 0; i < heads.length; i++) names.push((heads[i].textContent || '').replace(/\s+/g, ' ').trim());
    var rows = table.querySelectorAll('tbody tr');
    for (var r = 0; r < rows.length; r++) {
      var cells = rows[r].children;
      for (var c = 0; c < cells.length; c++) {
        if (names[c] && cells[c].getAttribute('data-label') !== names[c]) cells[c].setAttribute('data-label', names[c]);
      }
    }
  }
  function run() {
    var tables = document.querySelectorAll('.dealer-orders__table');
    for (var i = 0; i < tables.length; i++) label(tables[i]);
  }
  function init() {
    run();
    var bodies = document.querySelectorAll('.dealer-orders__table tbody');
    for (var i = 0; i < bodies.length; i++) new MutationObserver(run).observe(bodies[i], { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Mobile QA 2026-10-14 (M30): on phones the My Orders filter card filled the first screen.
   It starts collapsed there; the toggle in its header opens it. Desktop never collapses. */
(function () {
  function init() {
    var form = document.querySelector('.dealer-orders__filters');
    var btn = form && form.querySelector('[data-role="filters-toggle"]');
    if (!btn) return;
    function set(open) {
      form.classList.toggle('is-collapsed', !open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Hide filters' : 'Show filters';
    }
    set(!window.matchMedia('(max-width: 749px)').matches);
    btn.addEventListener('click', function () { set(form.classList.contains('is-collapsed')); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
